import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
export const rules = {
  name: [
      { required: true, message: 'Пожалуйста, введите название ', trigger: 'blur' },
      { min: 3, max: 255, message: 'Длина должна быть от 3 до 255', trigger: 'blur' }
  ]
    
};
